module.exports = __webpack_public_path__ + "media/images/redesign-images/get-inspired/gi-pinterest-5-e05f290c0d8380c11e33558873043f49.jpg";